import React , { useEffect, useState, useRef } from 'react';
import {Link} from 'react-router-dom';
// import Logo from '../assets/logos/gr-logo.jpg';
import logoEn from '../assets/logos/en-logo.png';
import logoGr from '../assets/logos/gr-logo.jpg';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import {ReactComponent as DownArrow} from '../assets/svgs/down-arrow.svg'
import {ReactComponent as RightArrow} from '../assets/svgs/right-arrow.svg'
import {ReactComponent as LanguagesSVG} from '../assets/svgs/languages.svg';
import {ReactComponent as ProfileSVG} from '../assets/svgs/profile-icon.svg';
import {ReactComponent as LogOutSVG} from '../assets/svgs/logout-dark.svg';
import {ReactComponent as HamburgerMenu} from '../assets/svgs/burger-menu.svg'
import { useNavigate } from 'react-router-dom';
import Aos from "aos";
import 'aos/dist/aos.css';
import { useAuth } from '../Auth.jsx'
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';

const Dropdown = styled.div`
  position: relative;
  margin-left: 20px;
  z-index: 2000;
`;

const LanguageDropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 20px); /* Position dropdown just below the button */
  left: 50%; /* Center horizontally */
  transform: translateX(-40%);
  background-color: #385963; 
  border: 1px solid #385963;
  border-radius: 10px;
  list-style: none;
  padding: 2px; 
  margin: 0;
  z-index: 9999;
  transition: 0.7s;
  display: flex;
  flex-direction: column; 
  align-items: stretch; 
  width: auto; 
  white-space: nowrap; 
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1); 
  color:white;
 
    &:focus-within{
    display: block;
  }

`;



const DropdownLanguageItem = styled.li`
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;
  font-size:13px;
  // text-align: left;
  &:hover {
    // background-color: #91abb3;
    color: #91abb3;
    border-radius: 10px;
  }
`;



const LogOutDiv = styled.div`
  display:flex;
  gap: 10px;
  margin-top: 8px;
  align-items:center;
  justify-content:flex-end;
  font-size: 13px;
  margin-left:10px;
  color:#385963;
   margin:0;
  p{
   margin:0;
  }

    &:hover {
    cursor: pointer;
  }

`;

const NavContainer = styled("nav")`
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  background-color: transparent;
  position: relative;
  z-index: 10;
  width:100%;
  gap:20px;


  // @media (max-width: 768px) {
  //   flex-direction: column;
  //   padding: 10px;
  // }

  // @media (max-width: 480px) {
  //   padding: 5px;
  //   justify-content: center;
  // }
`;

const LogoImage = styled("img")`
  height: 80px;
  width: 80px;
  background-color: transparent;

  @media (max-width: 768px) {
    height: 60px;
    width: 60px;
  }
  @media (max-width: 480px) {
    height: 50px;
    width: 50px;
  }
`;

const NavTabs = styled("ul")`
  display: flex;
  list-style: none;
  align-items: center;
  margin: 0;
 justify-content:center;

  & > li {
    margin-right: 10px;

    a {
      text-decoration: none;
      color: #385963;
      font-size: 13px;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;

      &:hover {
        color: #91abb3;
        transition: 0.4s;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 1.5px;
        bottom: 0;
        left: 50%;
        background-color: #538392;
        transition: all 0.4s;
      }

      &:hover::before {
        width: 100%;
        left: 0;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    // align-items: flex-start;
 padding:0;
    & > li {
      margin-bottom: 15px; /* Add spacing between items */
    }
      
  }

  @media (max-width: 480px) {
    & > li {
      margin-bottom: 10px;
    }

    a {
      font-size: 14px; /* Adjust font size for smaller screens */
    }
  }
`;


const DropdownMenu = styled("ul")`
  position: absolute;
  top: calc(100% + 20px);
  left: 50%;
  transform: translateX(-40%);
  background-color:rgb(56, 89, 99);
  border: 1px solid #385963;
  border-radius: 10px;
  list-style: none;
  padding: 15px;
  gap: 10px;
  margin: 0;
  z-index: 1000;
  transition: 0.7s;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  width: auto;
  white-space: nowrap;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  color: white;

  @media (max-width: 768px) {
    top: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    padding: 15px;
  }
`;

const DropdownButton = styled("button")`
  display: flex;
  align-items: center;
  background-color: transparent;
  color: #385963;
  border: none;
  cursor: pointer;
  font-size: 13px;
  padding: 0px 10px;

  svg {
    margin-left: 5px;
    width: 15px;
    height: 15px;
    color: #385963;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0px 8px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 0px 6px;
  }
`;


const MenuFlexBox = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  align-text:center;
`;


const AdminNavbar = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token") || "";
  const selectedLanguage = sessionStorage.getItem("selectedLanguage") || "en";
  const userRole = sessionStorage.getItem("userType");

  const [signedIn, setSignedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    Aos.init({ duration: 1000 });

    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Click outside logic
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavLinkClick = (path) => {
    setActiveLink(path);
    if (screenWidth <= 768) {
      setIsMenuOpen(false); // close burger menu on mobile
    }
  };

  const [activeLink, setActiveLink] = useState("/");

  const languages = [
    { code: "en", label: "EN" },
    { code: "gr", label: "GR" },
  ];

  const currentLanguage = languages.find(
    (lang) => lang.code === i18n.language
  );

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    sessionStorage.setItem("selectedLanguage", langCode);
    setDropdownOpen(false);
    window.location.reload();
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("userRole");
    toast.success("Logout Successful!");
    navigate("/register-signIn");
  };

  const handleLogout = () => {
    logout();
    navigate("/");
    window.location.reload();
  };

  const toggleBurgerMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const Logo = i18n.language === 'en' ? logoEn : logoGr;
  return (
    <NavContainer data-aos="fade-down">
      <Link to="/admin/dashboard" onClick={() => setActiveLink("/")}>
        <LogoImage src={Logo} />
      </Link>

      <MenuFlexBox>
        {screenWidth <= 768 && (
          <HamburgerMenu
            height={30}
            width={30}
            style={{ marginBottom: 10 }}
            onClick={toggleBurgerMenu}
          />
        )}

        {(screenWidth > 768 || isMenuOpen) && (
          <NavTabs>
            <li>
              <Link
                to="/admin/about-pieria"
                onClick={() => handleNavLinkClick("/admin-about-pieria")}
              >
                {i18n.t("aboutPieria")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/all-categories-admin"
                onClick={() => handleNavLinkClick("/all-categories-admin")}
              >
                {i18n.t("allCategories")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/users"
                onClick={() => handleNavLinkClick("/admin/users")}
              >
                {i18n.t("registeredUsers")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/providers"
                onClick={() => handleNavLinkClick("/admin/providers")}
              >
                {i18n.t("providers")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/destinations"
                onClick={() => handleNavLinkClick("/admin/destinations")}
              >
                {i18n.t("destinations")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/experiences"
                onClick={() => handleNavLinkClick("/admin/experiences")}
              >
                {i18n.t("experiences")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/events"
                onClick={() => handleNavLinkClick("/admin/events")}
              >
                {i18n.t("events")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/amenities"
                onClick={() => handleNavLinkClick("/admin/amenities")}
              >
                {i18n.t("amenities")}
              </Link>
            </li>

            <li>
              <Link
                to="/admin/requests"
                onClick={() => handleNavLinkClick("/admin/requests")}
              >
                {i18n.t("requests")}
              </Link>
            </li>

            <li onClick={handleLogout}>
              <LogOutDiv>
                <LogOutSVG height={18} width={18} />
                <div>{i18n.t("signOut")}</div>
              </LogOutDiv>
            </li>

            <li>
              <Dropdown>
                <DropdownButton
                  ref={buttonRef}
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  {currentLanguage ? currentLanguage.label : "EN"}
                  <LanguagesSVG height={18} width={18} />
                </DropdownButton>
                {dropdownOpen && (
                  <LanguageDropdownMenu ref={dropdownRef}>
                    {languages.map((lang) => (
                      <DropdownLanguageItem
                        key={lang.code}
                        onClick={() => changeLanguage(lang.code)}
                      >
                        {lang.label}
                      </DropdownLanguageItem>
                    ))}
                  </LanguageDropdownMenu>
                )}
              </Dropdown>
            </li>
          </NavTabs>
        )}
      </MenuFlexBox>
    </NavContainer>
  );
};

export default AdminNavbar;

